import { useQuery } from "@hooks/use_query";
import * as types from "@root/types";
import { api } from "@services/api";
import { useEffect, useMemo } from "react";

interface UseFetchContentBlockProps {
  id?: number | string;
}

const EMPTY_CONTENT_BLOCK = {
  body: undefined,
  id: undefined,
  page: undefined,
  section: undefined,
};

const useFetchContentBlock = ({ id }: UseFetchContentBlockProps) => {
  const apiCall = useMemo(() => {
    if (!id) {
      return (_token: string) => () =>
        Promise.resolve({ data: EMPTY_CONTENT_BLOCK, errors: undefined });
    }
    return (token: string) => () =>
      api.contentBlock.details(token, id.toString());
  }, [id]);
  const {
    data,
    fetchData: fetchContentBlock,
    loading,
    error,
  } = useQuery<types.ContentBlockDetailsResponse, UseFetchContentBlockProps>(
    apiCall,
  );

  useEffect(() => {
    fetchContentBlock({ id });
  }, [fetchContentBlock, id]);

  return {
    contentBlock: data,
    loading,
    error,
  };
};

export { useFetchContentBlock };
